import { Injectable } from "@angular/core";
import { IOrderAuditService, CHANNEL_AUDIT_SERVICE } from "../IOrderAuditService";
import { CoreOrderAudit } from "../../model/core/CoreOrderAudit";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderAuditReplicaService implements IOrderAuditService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_AUDIT_SERVICE, true, true);
  }

  public getOrderAudit(orderId: string, protocol: string): Promise<Array<CoreOrderAudit>> {
    let request = new UiArguments("getOrderAudit");

    let arg1 = new FnArg(orderId, PRIMITIVE);
    let arg2 = new FnArg(protocol, PRIMITIVE);
    request.args = [arg1, arg2];

    return this.runOnService(request, new Array<CoreOrderAudit>());
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
